/**
 * ONE BONE — the store credit ring's tooltip, in the header.
 *
 * The ring itself is drawn in Liquid and re-rendered by the cart, so nothing
 * here knows anything about tiers or money. All this owns is when the panel
 * beside it is open, which is the one thing a shopper on a touchscreen and a
 * shopper with a mouse do differently.
 *
 * Hover opens it where hovering is a thing the device does; everywhere else a
 * tap does, and hover is not bound at all. Binding both is what produces the
 * tap that opens and immediately closes again: a touchscreen fires a mouseenter
 * on tap, right before the click that would toggle it back. Asking the device
 * once, up front, is cheaper than untangling that afterwards.
 *
 * Registered from layout/theme.liquid rather than from the snippet, because a
 * script tag inside markup the cart re-renders never runs — and the ring is
 * replaced wholesale after every cart change. Alpine picks the new node up on
 * its own; the component only has to already be there when it does.
 */

(() => {
  document.addEventListener('alpine:init', () => {
    // The header renders the ring twice under the left-right mobile layout, and
    // theme.js may hand this file a fresh copy of both. Registering twice would
    // warn and clobber.
    if (window.__obCreditRingRegistered) return;
    window.__obCreditRingRegistered = true;

    Alpine.data('xCreditRing', () => ({
      open: false,

      /**
       * A mouse, or something else that can rest on a thing without pressing
       * it. Read once: a device does not grow a pointer mid-session, and the
       * answer decides whether hovering means anything at all here.
       */
      canHover: false,

      init() {
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      },

      /**
       * Tap to open, where tapping is the only way in. Where hovering is, the
       * panel is already open by the time a click lands and toggling it here
       * would shut it under the cursor that opened it.
       */
      toggle() {
        if (this.canHover) return;
        this.open = !this.open;
      },

      close() {
        this.open = false;
      },

      /**
       * Also the keyboard's way in: focus opens, blur closes, so the ring is
       * readable by tabbing to it and never needs the click that would leave
       * the panel open behind the shopper.
       */
      hover(isOver) {
        if (!this.canHover) return;
        this.open = isOver;
      }
    }));
  });
})();
